// Login.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";


export default function Login() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const loginData = JSON.parse(localStorage.getItem("loginData"));
    const now = new Date().getTime();

    if (loginData && now < loginData.expiry) {
      // اگر لاگین معتبر بود مستقیم هدایت به TicketsPage
      navigate("/ticketsPage", { replace: true });
    } else {
      // اگر زمانش گذشته بود، پاکش کن
      localStorage.removeItem("loginData");
    }
  }, [navigate]);

  const handleLogin = (e) => {
    e.preventDefault();

    if (username === "admin" && password === "admin") {
      const expiry = new Date().getTime() + 2 * 60 * 60 * 1000; // دو ساعت
      localStorage.setItem(
        "loginData",
        JSON.stringify({ username, expiry })
      );
      setMessage(`ورود موفق! خوش آمدید ${username}`);
      setTimeout(() => navigate("/ticketsPage", { replace: true }), 500);
    } else {
      setMessage("نام کاربری یا رمز عبور اشتباه است.");
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="card p-4 shadow" style={{ minWidth: "350px" }}>
        <h3 className="text-center mb-3">ورود به سیستم</h3>
        {message && <div className="alert alert-info">{message}</div>}
        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label className="form-label">نام کاربری</label>
            <input
              type="text"
              className="form-control"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">رمز عبور</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary w-100">
            ورود
          </button>
        </form>
      </div>
    </div>
  );
}
